export default __webpack_public_path__ + "static/media/stockmarket.ad41d291.jpg";